import {useMemo} from "react";
import {useSelector} from "react-redux";

export default () => {

	const {strings} = useSelector(store => store);

	return useMemo(() => {
		return {
			...strings
		};
	}, [strings]);

};
